// Mobile app development pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const MOBILE_META_DATA: PageHeadMeta = {
    title: 'Mobile App Development Services | Debut Infotech',
    img: cdnUrl('mobile-app-new-images/Mobile-App-Development-Company.jpg'),
    description:
        'Explore mobile app development services from Debut Infotech. We build secure iOS, Android and cross-platform apps, from UI/UX design to launch and support.'
};

export const IOS_META_DATA: PageHeadMeta = {
    title: 'iOS App Development Services | Debut Infotech',
    img: cdnUrl('ios/ios-App-Development-Company.jpg'),
    description:
        'Build secure, scalable iOS apps for iPhone and iPad with Debut Infotech. Get custom development, API integration, migration, testing, and ongoing support.'
};

export const ANDROID_META_DATA: PageHeadMeta = {
    title: 'Android App Development Company | Debut Infotech',
    img: cdnUrl('android/Android-App-Development-Company.jpg'),
    description:
        'Debut Infotech provides custom Android app development services to help businesses build secure and scalable applications with seamless integrations and ongoing support.'
};

export const HYBRID_META_DATA: PageHeadMeta = {
    title: 'Hybrid Mobile App Development Company',
    img: cdnUrl('hybrid-app/Hybrid-App-Development-Company.jpg'),
    description:
        'Boost your business with a top hybrid mobile development company offering scalable, cross-platform hybrid mobile app development services tailored to your needs.'
};

export const REACT_NATIVE_META_DATA: PageHeadMeta = {
    title: 'Top React Native App Development Company',
    img: cdnUrl('reactnative/React-Native-App-Development-Company.jpg'),
    description:
        'Hire a leading React Native app development company to build high-performance cross-platform apps with seamless user experience and native feel.'
};

export const FLUTTER_META_DATA: PageHeadMeta = {
    title: 'Flutter App Development Company in USA',
    img: cdnUrl('flutter-app/Flutter-App-Development-Company.jpg'),
    description:
        'We offer Flutter application development services to build fast, scalable, and cross-platform mobile apps tailored to your business goals and customer experience.'
};

export const ON_DEMAND_META_DATA: PageHeadMeta = {
    title: 'On-Demand App Development Company - Debut Infotech',
    img: cdnUrl('On-demand-app/On-Demand-App-Development-Company.jpg'),
    description:
        'At Debut Infotech, we develop on-demand apps with interactive user experiences that help service providers meet the needs of their customers.'
};

export const WEARABLE_APP_DEVELOPMENT: PageHeadMeta = {
    title: 'Wearable App Development Company',
    description:
        'Debut Infotech, a top Wearable App Development Company, crafts secure, high-performance apps for fitness, health, enterprise, and AR wearables with smooth UX.',
    img: cdnUrl('Wearable-App/wearable-app-development-company.jpg')
};

export const PROGRESSIVE_WEB_APP_DEVELOPMENT: PageHeadMeta = {
    title: 'Progressive Web App Development Services',
    description:
        'Boost engagement with our Progressive Web App Development Services—fast, reliable, and engaging apps that work seamlessly across all devices and platforms.',
    img: cdnUrl('PWA-development/PWA-Development-Company.jpg')
};

export const KOTLIN_APP_DEVELOPMENT: PageHeadMeta = {
    title: 'Top Kotlin App Development Company',
    description:
        'Build powerful, modern mobile apps with our Kotlin app development company. Expert solutions tailored to Android and cross-platform needs.',
    img: cdnUrl('kotlin-development/Kotlin-App-Development.jpg')
};

export const ENTERPRISE_MOBILE_DEVELOPMENT_SERVICES: PageHeadMeta = {
    title: 'Enterprise Mobile App Development Services',
    description:
        'We offer enterprise mobile app development services that deliver secure, scalable, and custom apps to streamline operations, enhance productivity, and fuel growth.',
    img: cdnUrl('Enterprise-Mobile-App-Development/Enterprise-Mobile-app-Development-Company.jpg')
};

export const APP_MAINTENANCE_SERVICES: PageHeadMeta = {
    title: 'Mobile App Maintenance Services',
    img: cdnUrl('Mobile-App-Maintenance-Services/Mobile-App-Maintenance-Services.jpg'),
    description:
        'We offer reliable mobile app maintenance services to fix bugs, improve performance, ensure security updates, and keep your apps stable across platforms'
};

export const CROSS_PLATFORM_APP_DEVELOPMENT: PageHeadMeta = {
    title: 'Cross Platform App Development Services',
    img: cdnUrl('Cross-Platform-App-Development/Cross-Platform-App-Development-Company .jpg'),
    description:
        'We deliver seamless experiences with Cross Platform App Development Services. Build scalable apps faster, reduce costs, and engage users on iOS & Android.'
};
